// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-p_fv","advertDetailContacts__header":"c-p_fw"};